import { Component, HostListener, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/platform-browser";
import { Router, ActivatedRoute, Params } from "@angular/router";
import CBAErrorHandler from "../../error/error.handler";
import { environment } from "../../../environments/environment";

import * as _ from "underscore";
declare var Carousel: any;
declare var $: any;

import { AllProductsService } from "./all_products.service";
import { FiltersService } from "../filters.service";

@Component({
  selector: "app-all-products",
  templateUrl: "./all-products.component.html",
  styleUrls: ["./all-products.component.css"],
  providers: [AllProductsService, FiltersService]
})
export class AllProductsComponent {
  private isSearchHidden: boolean = true;
  private isNavHidden = true;

  private isLoading = true;

  private products = null;
  private originalProducts = null;

  private listName = null;
  private listId = null;
  private userId = null;
  private imageUnavailablePath = "/assets/images/image_unavailable_medium.jpg";
  private activeAsrt = null;
  private asrtHeaderHeight = 170;
  private asrtContent;
  private isChangeListHidden = true;
  private isCustomerList = false;
  private isCustomerLoggedIn = false;
  public magicLink = null;
  private region = null;
  private season = null;
  private authId = null;

  private filterData = null;
  private filterOrders = null;
  private filterKeys = null;
  public queryFilterData = null;
  public downloadOptions = false;
  public required_token = false;
  public onDisplayBiggerImage = false;
  public topImageIndex;
  public asrtImageIndex;
  public collImageIndex;
  public groupColorIndex;
  public topImage = {};
  public thumbImageIndex;
  public groupedColors;
  public idIndex = {};
  public clickableIdx;
  public activeIdx;
  public activeRowIndex;
  public activeCollIndex;
  public activeAsrtIndex;
  public country;

  updatedValues: any = {};
  public filterModal: boolean = false;

  public filterVals = null;
  public filterAllValues = [];
  public updatedFacetValues = [];
  public filter_data;
  public activeFilter = false;
  public filterSelected;
  private displaySeason = null;
  private seasonName;

  public ENV = environment;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private productsService: AllProductsService,
    private filtersService: FiltersService
  ) {
    let unsetKey = [
      "seasonVal",
      "season",
      "user_id",
      "user_details",
      "magic_link",
      "cust_email",
      "display_season",
      "list_name"
    ];
    this.removeKeyFromLS(unsetKey);
    this.route.params.subscribe((params: Params) => {
      let season = params["season"];

      // let allProducts = params["all"]
      this.seasonName = this.getAbbrDisplaySeason(season);
      this.setKeyInLS("seasonVal", this.seasonName);
      this.setKeyInLS("season", this.seasonName.toUpperCase());
      let pAuthId = localStorage.getItem("product_authId");
      if (params["id"]) {
        this.authId = params["id"];
        if (this.authId != pAuthId) {
          this.required_token = true;
          localStorage.setItem("product_authId", this.authId);
        }
      }

      if (season) {
        this.season = season;
        let retailFilt = localStorage.getItem("filter_values");
        if (retailFilt && retailFilt.length > 0) {
          this.filterKeys = JSON.parse(retailFilt);
        }
        let filetrs = localStorage.getItem("appliedFilterValues");
        if (filetrs && Object.keys(filetrs).length > 0) {
          this.updatedValues = JSON.parse(filetrs);
          this.udpateFilterFacets();
        }

        let filters = {
          season: this.season,
          authId: this.authId,
          filter: this.getRequiredFilters(),
          required_token: this.required_token
        };

        this.loadProducts(filters);
      }
    });
  }

  removeKeyFromLS(keys) {
    for (let k of keys) {
      if (localStorage.hasOwnProperty(k)) {
        localStorage.removeItem(k);
      }
    }
  }

  setKeyInLS(key, value) {
    localStorage.setItem(key, value);
  }

  getAbbrDisplaySeason(season) {
    season = season || "";
    let dispSeason = season.split("-");
    if (dispSeason && dispSeason[0]) {
      dispSeason = dispSeason[0].toUpperCase();
      if (dispSeason.startsWith("AW")) {
        if (dispSeason.length == 4) {
          return "AW" + dispSeason.substr(2, 2);
        }
        if (dispSeason.length == 6) {
          return "AW" + dispSeason.substr(4, 2);
        }
      } else if (dispSeason.startsWith("SS")) {
        if (dispSeason.length == 4) {
          return "SS" + dispSeason.substr(2, 2);
        }
        if (dispSeason.length == 6) {
          return "SS" + dispSeason.substr(4, 2);
        }
      }
    } else {
      return season;
    }
  }

  ngOnInit() {
    $(window)
      .scroll(function () {
        var scrollDistance = $(window).scrollTop() + 300;

        // Assign active class to nav links while scolling
        $(".page-sections").each(function (i) {
          if ($(this).position().top <= scrollDistance) {
            $(".navmenu ul li a.active").removeClass("active");
            $(".navmenu ul li a").eq(i).addClass("active");
          }
        });
      })
      .scroll();
  }

  closeThumb(ev) {
    this.onDisplayBiggerImage = false;
    this.activeIdx = null;
  }

  loadProducts(filters = {}) {
    this.isLoading = true;

    this.productsService
      .getAllProducts(filters)
      .then(res => {
        if (res) {
          this.season = res.season;
          this.region = res.region;
          this.listId = res.list_id;
          this.country = res.country;
        }

        this.products = this.formatProducts(res.products);
        this.originalProducts = Object.assign({}, this.products);

        if (this.products["assortments"] && this.products["assortments"][0]) {
          this.activeAsrt = this.products["assortments"][0]["classname"];
        }
        if (this.updatedValues && this.updatedValues.length == 0) {
          this.isLoading = false;
          this.scrollToSelectedProduct();
        }

        return this.filtersService.getFilters(
          this.season,
          this.region,
          this.listId,
          this.country,
          this.getRequiredFilters()
        );
      })
      .then(res => {
        this.filterData = res.filters;

        this.formatFilterOrders();
      })
      .then(res => {
        // if (this.updatedValues && this.updatedValues.length > 0) {
        this.isLoading = false;
        this.required_token = false;
        this.scrollToSelectedProduct();
        // this.onSubmit(null);
        // }
      })
      .catch(e => {
        this.handleError(e);
        this.isLoading = false;
      });
  }

  removeFilterFacet(val) {
    this.updatedFacetValues = this.updatedFacetValues.filter(
      as => !(as.key == val.key && as.subKey == val.subKey)
    );
    if (val.key && this.updatedValues[val.key]) {
      if (
        this.updatedValues[val.key] &&
        this.updatedValues[val.key].includes(val.subKey)
      ) {
        let index = this.updatedValues[val.key].indexOf(val.subKey);
        this.updatedValues[val.key].splice(index, 1);
      }

      localStorage.setItem(
        "appliedFilterValues",
        JSON.stringify(this.updatedValues)
      );

      this.refreshProduct();
    }
  }

  clearAllFilters() {
    this.updatedValues = {};
    this.updatedFacetValues = [];
    localStorage.setItem(
      "appliedFilterValues",
      JSON.stringify(this.updatedValues)
    );
    this.refreshProduct();
  }

  scrollToSelectedProduct() {
    if (localStorage.hasOwnProperty("product_data")) {
      let scrollToProduct = localStorage.getItem("product_data");
      let itemWithoutDot = scrollToProduct.replace(/\./g, "");
      let itemWithoutSpace = itemWithoutDot.replace(/\s+/g, "-");
      let mobileScreen = $(window).width() <= 1100;
      if (mobileScreen) {
        setTimeout(() => {
          $("html,body").animate(
            {
              scrollTop: $("#" + itemWithoutSpace).offset().top - 35
            },
            1000
          );
        }, 2000);
      } else {
        setTimeout(() => {
          $("html,body").animate(
            {
              scrollTop: $("#" + itemWithoutSpace).offset().top - 253
            },
            1000
          );
        }, 2000);
      }
      setTimeout(() => {
        localStorage.removeItem("product_data");
      }, 5000);
    }
  }

  onDownload(): any {
    this.downloadOptions = !this.downloadOptions;
  }
  closeDownloadOptions(): any {
    this.downloadOptions = false;
  }

  clickNavMenu(asrt) {
    var mobileWindow = $(window).width() <= 800;
    if (mobileWindow) {
      $(".navbar-toggle").click();
    }
    $("html,body").animate(
      {
        scrollTop: $("#" + asrt.classname).offset().top - 100
      },
      1000
    );
    return false;
  }
  sortItems(a, b) {
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  }

  getThumbImage(image) {
    if (image) {
      return image;
    } else {
      return this.imageUnavailablePath;
    }
  }

  toggleNav() {
    this.isNavHidden = !this.isNavHidden;
  }

  formatFilterData() {
    this.queryFilterData = [];

    let filterAsrts = this.filterData["assortments"];
    let newFilterAsrts = [];
    for (let prodAsrt of this.originalProducts["assortments"]) {
      let filterAsrt = _.findWhere(filterAsrts, { name: prodAsrt["name"] });
      if (!filterAsrt) {
        continue;
      }

      let filterColls = filterAsrt["collections"];
      let newFilterColls = [];
      for (let prodColl of prodAsrt["collections"]) {
        let filterColl = _.findWhere(filterColls, { name: prodColl["name"] });
        if (!filterColl) {
          continue;
        }

        let filterItems = filterColl["filters"];
        let newFilterItems = [];

        let prodItems = _.pluck(prodColl["items"], "name");
        for (let item of filterItems) {
          let filterOptions = item["options"];
          let newFilterOptions = [];
          for (let option of filterOptions) {
            let isItemPresent =
              _.union(option["items"], prodItems).length <
              prodItems.length + option["items"].length;
            if (isItemPresent) {
              newFilterOptions.push(option);
              this.queryFilterData.push({
                assortment: prodAsrt["name"],
                collection: prodColl["name"],
                query: option["query"],
                items: option["items"],
                filter: item["name"]
              });
            }
          }
          if (newFilterOptions.length > 0) {
            item["options"] = newFilterOptions;
            newFilterItems.push(item);
          }
        }
        if (newFilterItems.length > 0) {
          filterColl["filters"] = newFilterItems;
          newFilterColls.push(filterColl);
        }
      }
      if (newFilterColls.length > 0) {
        filterAsrt["collections"] = newFilterColls;
        newFilterAsrts.push(filterAsrt);
      }
    }
    this.filterData["assortments"] = newFilterAsrts;
  }

  formatProducts(data) {
    for (let asrt of data["assortments"]) {
      asrt["classname"] = this.sanitiseName(asrt.name);
      for (let coll of asrt["collections"]) {
        for (let item of coll["items"]) {
          item["isAccessories"] = this.isAccessories(asrt.name, coll.name);
          item["detailclass"] = this.sanitiseNameWithoutDot(item.name, item.id);
          item["groupedColors"] = [];
          let i = 0;
          let tmpColors = [];
          let allcolors = this.getAllIds(item);
          for (let color of item["colors"]) {
            let fitting = "";
            if (color.fit) fitting += color.fit;
            if (color.size) fitting += "/" + color.size;
            if (this.region == "AMERICAS" && color.us_fits) {
              fitting = color.us_fits;
            }
            color["fitting"] = fitting;

            if (color && color.currencies) {
              let rrp = color.rrp_price;
              if (rrp.value != "0") {
                if (rrp.value && Array.isArray(rrp.value)) {
                  color["rrp"] = rrp.value.map(v => rrp.code + " " + v);
                } else {
                  color["rrp"] = rrp.code + " " + rrp.value;
                }
                color["is_us"] = rrp.code == "USD" ? true : false;
              }
            }

            color["style"] = item.name;
            color["lining"] = item.lining;
            color["sock"] = item.sock;
            color["upper"] = item.upper;
            color["construction"] = item.construction;
            color["sole"] = item.sole;
            color["fit"] = item.fit;
            color["status"] = item.status;
            color["all_colors"] = allcolors.toString();
            color["heel_height"] = item.heel_height;

            tmpColors.push(color);
            i += 1;
            //So, only 4 colors will be shown in one row
            if (i % 4 == 0) {
              item["groupedColors"].push(tmpColors);
              tmpColors = [];
            }
          }

          if (tmpColors.length > 0) {
            item["groupedColors"].push(tmpColors);
          }
        }
      }
    }

    return data;
  }

  getAllIds(item) {
    let colorList = [];
    for (let col of item["colors"]) {
      colorList.push(col.id);
    }
    return _.uniq(colorList);
  }

  formatFilterOrders() {
    let orders = this.formatFilterOrder(this.filterOrders);
    for (let assort of this.filterData["assortments"]) {
      for (let coll of assort["collections"]) {
        for (let filter of coll["filters"]) {
          let existVals = orders[filter.name].values;
          let tmpValues = _.pluck(filter["options"], "name");
          orders[filter.name].values = _.union(existVals, tmpValues).sort();
          let existQueries = orders[filter.name].queries;
          let tmpQueries = _.pluck(filter["options"], "query");
          orders[filter.name].queries = _.union(
            existQueries,
            tmpQueries
          ).sort();
        }
      }
    }
    this.filterKeys = Object.keys(orders);
    this.filterOrders = orders;
  }

  sanitiseName(asrtName) {
    return asrtName.split(" ").join("-");
  }

  sanitiseNameWithoutDot(itemName, itemId) {
    let itemWithoutDot = itemName.replace(/\./g, "");
    let itemWithoutSpace = itemWithoutDot.replace(/\s+/g, "-");
    return itemWithoutSpace;
  }

  isAccessories(asrtName, collName) {
    return (
      asrtName.trim().toLowerCase() === "accessories" ||
      collName.trim().toLowerCase() === "accessories"
    );
  }

  handleError(e) {
    console.error(e);
    if (e._body) {
      try {
        let serverResponse = JSON.parse(e._body);
        e.statusText = serverResponse["message"];
      } catch (e) {}
    }

    if (e.status === 403) {
      this.router.navigateByUrl("/error/not-authorised");
    } else if (e.status === 404) {
      this.router.navigateByUrl("/error/not-found");
    } else {
      let errorHandler = new CBAErrorHandler();
      //errorHandler.notifyRaven(e);
      this.router.navigateByUrl("/error/internal-error");
    }
  }

  formatFilterOrder(filterOrders) {
    let orders = {};
    for (let order of filterOrders["order"]) {
      let tmpOrder = { name: order, values: [], queries: [] };
      orders[order] = tmpOrder;
    }
    return orders;
  }

  showFilterModal() {
    this.filterModal = true;
  }

  closeFilterModal() {
    this.filterModal = false;
  }

  updateFilterValue(key, valIdx, val, isChecked) {
    if (isChecked) {
      if (!this.updatedValues[key]) {
        this.updatedValues[key] = [];
      }
      if (!this.updatedValues[key].includes(val)) {
        this.updatedValues[key].push(val);
      }
      localStorage.setItem(
        "appliedFilterValues",
        JSON.stringify(this.updatedValues)
      );
    } else {
      if (this.updatedValues && this.updatedValues[key]) {
        if (this.updatedValues[key].includes(val)) {
          let index = this.updatedValues[key].indexOf(val);
          this.updatedValues[key].splice(index, 1);
        }
      }
    }

    localStorage.setItem(
      "appliedFilterValues",
      JSON.stringify(this.updatedValues)
    );

    this.udpateFilterFacets();
    this.refreshProduct();
  }

  udpateFilterFacets() {
    let filterArr = [];
    for (let i of Object.keys(this.updatedValues)) {
      if (this.updatedValues[i] && this.updatedValues[i].length > 0) {
        for (let f of this.updatedValues[i]) {
          let obj = {};
          obj["key"] = i;
          obj["originalKey"] = i; // we can change in what way we want to show
          obj["subKey"] = f;
          obj["originalSubkey"] = f;
          filterArr.push(obj);
        }
      }
    }
    this.updatedFacetValues = filterArr;
  }

  refreshProduct() {
    let filters = {
      season: this.season,
      authId: this.authId,
      filter: this.getRequiredFilters(),
      required_token: this.required_token
    };
    // change to fitler values
    this.loadProducts(filters);
  }

  isFilterValueChecked(key, value, valIdx) {
    return (
      this.updatedValues &&
      this.updatedValues[key] &&
      this.updatedValues[key].indexOf(value) > -1
    );
  }

  showFilterValues(key) {
    if (this.filterData && this.filterData.length > 0) {
      let filterVal = this.filterData.filter(as => as.label == key);
      if (filterVal && filterVal[0] && filterVal[0].options) {
        this.filterAllValues = this.getOptions(filterVal[0].options);
        this.filterVals = filterVal[0].key;
      }
    }
  }

  getOptions(options) {
    return options.filter(as => as);
  }

  hideFilterVals() {
    this.filterVals = null;
  }

  getRequiredFilters() {
    let newFilters = {};
    for (let f of Object.keys(this.updatedValues)) {
      if (this.updatedValues[f] && this.updatedValues[f].length > 0) {
        newFilters[f] = this.updatedValues[f];
      }
    }
    return JSON.stringify(newFilters);
  }

  onSubmit(form) {
    this.filterModal = false;
    if (_.isEmpty(this.updatedValues)) {
      this.products = this.originalProducts;
      return;
    }

    let filteredQueries = [];
    for (let val of this.updatedValues) {
      let tmp = _.where(this.queryFilterData, { query: val });
      filteredQueries = filteredQueries.concat(tmp);
    }

    let groupedFilters = _.groupBy(filteredQueries, "filter");
    let products = [];
    for (let filterGroup in groupedFilters) {
      let unionprods = [];
      for (let query of groupedFilters[filterGroup]) {
        let unionTmp = _.findWhere(unionprods, {
          assortment: query["assortment"],
          collection: query["collection"]
        });
        if (!unionTmp) {
          unionTmp = {
            assortment: query["assortment"],
            collection: query["collection"],
            items: []
          };
          unionprods.push(unionTmp);
        }
        unionTmp["items"] = _.union(unionTmp["items"], query["items"]);
      }
      products.push(unionprods);
    }

    let intersectProds = [];
    if (products && products.length > 0) {
      intersectProds = intersectProds.concat(products[0]);
    }
    for (let unionprods of products) {
      intersectProds = intersectProds.filter(i => {
        let t = _.findWhere(unionprods, {
          assortment: i["assortment"],
          collection: i["collection"]
        });
        return t;
      });
      for (let query of unionprods) {
        let intersectTmp = _.findWhere(intersectProds, {
          assortment: query["assortment"],
          collection: query["collection"]
        });
        if (!intersectTmp) {
          continue;
        }
        intersectTmp["items"] = _.intersection(
          intersectTmp["items"],
          query["items"]
        );
      }
    }
    intersectProds = intersectProds.filter(i => {
      return i["items"] && i["items"].length > 0;
    });
    this.setFilteredProducts(intersectProds);
  }

  setFilteredProducts(filteredQueries) {
    let newAsrts = [];
    for (let query of filteredQueries) {
      let isNewArt = false;
      let isNewColl = false;
      let asrt = _.findWhere(this.originalProducts["assortments"], {
        name: query["assortment"]
      });
      let newAsrt = _.findWhere(newAsrts, { name: query["assortment"] });
      if (!newAsrt) {
        newAsrt = Object.assign({}, asrt);
        newAsrt["collections"] = [];
        isNewArt = true;
      }

      let newColls = newAsrt["collections"];
      let coll = _.findWhere(asrt["collections"], {
        name: query["collection"]
      });
      let newColl = _.findWhere(newColls, { name: query["collection"] });
      if (!newColl) {
        newColl = Object.assign({}, coll);
        newColl["items"] = [];
        isNewColl = true;
      }

      let newItems = newColl["items"];
      let items = coll["items"].filter(i => {
        return query["items"].indexOf(i.name) > -1;
      });

      for (let i of items) {
        let tmp = _.findWhere(newItems, { name: i.name });
        if (!tmp) {
          let t = Object.assign({}, i);
          newItems.push(t);
        }
      }

      newColl["items"] = newItems;
      if (isNewColl) {
        newColls.push(newColl);
      }
      if (isNewArt) {
        newAsrts.push(newAsrt);
      }
    }

    let products = Object.assign({}, this.originalProducts);
    products["assortments"] = newAsrts;
    this.products = products;
  }

  toCamelCase(str) {
    if (!str) {
      return "";
    }
    str = str.toLowerCase();
    let splitStr = str.split(/[\_ ]+/);
    for (let idx in splitStr) {
      let tmp = splitStr[idx];
      tmp = tmp.charAt(0).toUpperCase() + tmp.slice(1);
      splitStr[idx] = tmp;
    }
    str = splitStr.join("");
    str = str.charAt(0).toLowerCase() + str.slice(1);
    return str;
  }
}



// WEBPACK FOOTER //
// ./src/app/products/all-products/all-products.component.ts